import { TraitRegistryEventFromTraitRegistry } from './TraitRegistryEventFromRegistry';
import { TraitRegistryEventBasic } from './TraitRegistryEventBasic';
import { TraitRegistryCategory } from '../TraitRegistryCategory';
export class TraitRegistryEvent extends TraitRegistryCategory {
    label = 'Events';
    get allLeafs() {
        return super.allLeafs;
    }
    c_fE = new TraitRegistryEventFromTraitRegistry(this);
    c_cE = new TraitRegistryEventBasic(this);
}
